// import criticalIcon from '@root/assets/svg/Compliance_V1/Critical.svg';
// import highIcon from '@root/assets/svg/Compliance_V1/High.svg';
// import lowIcon from '@root/assets/svg/Compliance_V1/Low.svg';
// import mediumIcon from '@root/assets/svg/Compliance_V1/Medium.svg';

import Text from '@root/components/v2/ui-elements/Text';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
// import atlassian_jira_logo_icon from '@assets/svg/atlassian_jira_logo_icon.svg';
import WorkloadVulnerabilities from '@root/assets/svg/Kubernetes/WorkloadVulnerabilities';

// import fix_available_check from '@root/assets/svg/workload/green_tick_icon_new.svg';
import info from '@root/assets/svg/workload/info.svg';
import question1 from '@root/assets/svg/workload/question1.png';

// import DateFormatPipe from '@root/components/utilities/DateFormatPipe';
import { SeverityWithText } from '@root/components/bootstrapTable/badges/severity';

import { Box } from '@mui/material';
import { severityDarkColors, severityLightColors } from '@root/components/bootstrapTable/badges/severity';
// import HighIcon from '@root/components/svg/high';
// import CriticalIcon from '@root/components/svg/criticalIcon';
// import MediumIcon from '@root/components/svg/mediumIcon';
// import LowIcon from '@root/components/svg/lowIcon';

export const columns = (isSbom = false) => {
  return [
    {
      field: 'cve_id',
      headerName: 'CVE ID',
      classes: 'align-middle',
      minWidth: 200,
      sort: true,
      renderCell: params => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Box sx={{ background: 'rgb(243, 244, 246)', padding: '5px', borderRadius: '.5rem' }}>
            <WorkloadVulnerabilities height="16px" width="16px" />
          </Box>

          <Tooltip title={isSbom ? params.row?.vulnerability_id : params.row?.cve_id}>
            <Text fontWeight={500} style={{ width: '170px' }} className="SingleLine">
              {isSbom ? params.row?.vulnerability_id : params.row?.cve_id}
            </Text>
          </Tooltip>
        </div>
      ),
    },

    {
      field: 'severity',
      headerName: 'CVSS Severity',
      classes: 'align-middle',
      minWidth: 200,
      sort: true,
      renderCell: params => {
        const severity = params.row?.severity?.toUpperCase();
        return (
          <Tooltip title={params.row?.severity}>
            {severity !== 'INFORMATIONAL' && severity !== 'UNTRIAGED' ? (
              <SeverityWithText propsValue={params.row?.severity} />
            ) : severity === 'INFORMATIONAL' ? (
              <img src={info} style={{ height: '30px', width: '30px' }} />
            ) : (
              <img src={question1} style={{ height: '30px', width: '30px' }} />
            )}
          </Tooltip>
        );
      },
    },

    {
      field: 'cvss_score',
      headerName: 'CVSS Score',
      classes: 'align-middle',
      minWidth: 200,
      sort: true,
      renderCell: params => {
        const score =
          params.row?.cvss_score === 0 || !params.row?.cvss_score ? 0 : parseFloat(params.row?.cvss_score).toFixed(1);

        const colorSeverity = params.row?.severity;
        const backgroundDarkColor = severityDarkColors[colorSeverity?.toUpperCase()] || severityDarkColors.DEFAULT;
        const backgroundLightColor = severityLightColors[colorSeverity?.toUpperCase()] || severityLightColors.DEFAULT;

        const version = params.row?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.version
          ? `v${params.row.details.cvssMetricV31.cvssMetricV31[0].cvssData.version}`
          : params.row?.details?.Vector?.match(/CVSS:(\d+\.\d+)/)?.[1]
          ? `v${params.row.details.Vector.match(/CVSS:(\d+\.\d+)/)[1]}`
          : 'v3.0';

        return (
          <div style={{ display: 'flex', alignItems: 'center', borderRadius: '5px', overflow: 'hidden' }}>
            <div
              style={{
                backgroundColor: backgroundDarkColor,
                padding: '3px 7px',
                color: '#FFFFFF', // Dark gray for better readability on pastel backgrounds
                fontFamily: 'Manrope',
                fontWeight: 500,
                fontSize: '12px',
              }}>
              {score}
            </div>
            <div
              style={{
                backgroundColor: backgroundLightColor,
                padding: '3px 7px',
                color: '#5D0E61', // Dark gray for better readability
                fontFamily: 'Manrope',
                fontWeight: 500,
                fontSize: '12px',
              }}>
              {version}
            </div>
          </div>
        );
      },
    },

    {
      field: 'exploitability_score',
      headerName: 'EPSS Score',
      classes: 'align-middle',
      minWidth: 200,
      sortable: false,
      renderCell: params => (
        <Tooltip title={params.row?.threat_trend_data?.Vendor ?? ''}>
          <Text fontWeight={500} className="SingleLine">
            {(params.row?.exploitability_score ?? 0).toFixed(2)}
          </Text>
        </Tooltip>
      ),
    },

    {
      field: 'exploitable',
      headerName: 'Exploitable',
      classes: 'align-middle',
      minWidth: 200,
      sortable: false,
      renderCell: params => (
        <Tooltip title={params.row?.threat_trend_data?.Vendor ?? ''}>
          <Text fontWeight={500} className="SingleLine">
            {params.row?.exploitable ? 'Yes' : 'No'}
          </Text>
        </Tooltip>
      ),
    },

    isSbom
      ? {
          field: 'workload_name',
          headerName: 'Workload',
          classes: 'align-middle',
          minWidth: 300,
          sortable: false,
          renderCell: params => (
            <Box display={'flex'} flexDirection={'column'} gap={'4px'} width={'100%'}>
              <Tooltip title={params?.row?.workload_name ?? '-'}>
                <Text className="m-0 SingleLine">{params?.row?.workload_name ?? '-'}</Text>
              </Tooltip>
              <Tooltip title={params.row.workload_kind}>
                <Text className="m-0 SingleLine">{params?.row?.workload_kind ?? '-'}</Text>
              </Tooltip>
            </Box>
          ),
        }
      : {
          field: 'path',
          headerName: 'Path',
          classes: 'align-middle',
          minWidth: 200,
        },

    {
      field: 'status',
      headerName: 'Status',
      classes: 'align-middle',
      minWidth: 200,
      sortable: false,
      renderCell: params => (params.row?.status === 'active' ? 'Active' : 'Inactive'),
    },
  ];
};
